import { Reveal, RevealLine } from "@/components/Reveal";

const CARDS = [
  { n: "I", title: "Gold Is Emotional", tag: "Faith · Blessings · Celebration" },
  { n: "II", title: "Year-Round Demand", tag: "Diwali · Weddings · Eid · Corporate" },
  { n: "III", title: "Low Competition", tag: "No global incumbent" },
  { n: "IV", title: "Designed for Diaspora", tag: "Culturally familiar · Aesthetically modern" },
];

export default function CategoryWins() {
  return (
    <section
      id="category"
      data-testid="section-category"
      className="deck-section relative bg-ink"
    >
      <div className="mx-auto w-full max-w-[1600px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <Reveal>
          <div className="num-overline">03 · The Opportunity</div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <Reveal delay={0.1} className="lg:col-span-7">
            <h2 className="font-heading text-ivory text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tightest">
              Why this category{" "}
              <span className="italic text-gold">wins</span> globally.
            </h2>
          </Reveal>
          <Reveal delay={0.2} className="lg:col-span-5">
            <p className="font-body text-beige/70 text-[14px] leading-[1.7] max-w-md">
              A category with enormous international headroom — rooted in
              emotion, sustained by a year-round festival calendar.
            </p>
          </Reveal>
        </div>

        {/* Minimal 4-column horizontal list */}
        <div className="mt-16 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px bg-gold/12">
          {CARDS.map((c, i) => (
            <Reveal key={i} delay={0.1 + i * 0.08}>
              <article className="group h-full bg-ink px-6 md:px-8 py-10 md:py-12 flex flex-col gap-6 transition-colors duration-700 ease-luxe hover:bg-coal min-h-[200px]">
                <div className="flex items-baseline gap-3">
                  <span className="font-heading italic text-gold text-base">
                    {c.n}
                  </span>
                  <RevealLine delay={0.3 + i * 0.05} className="flex-1" />
                </div>
                <div>
                  <h3 className="font-heading text-ivory text-xl md:text-2xl leading-tight">
                    {c.title}
                  </h3>
                  <div className="mt-3 font-body text-[11.5px] uppercase tracking-[0.2em] text-beige/55">
                    {c.tag}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
